/* eslint-disable no-unused-vars */
import React, { Fragment } from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { classInfo } from '../Store/api/classApi';
import { all as allBooks, show as singleBook } from '../Store/api/books';
import { getBook } from '../Store/api/student';
import { setChapter, setSection } from '../Store/ui/reader';
import 'react-toastify/dist/ReactToastify.css';
import greyledTeach from '../images/logo.svg';
import greyledRead from '../images/greyledread.png';
// import greyledLearn from "../assets/images/greyled-learns-logo.svg";
import greyledLearn from '../assets/images/grayledlearns.png';
import { Portal } from 'react-overlays';
import funnel from '../images/funnel.svg';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-loading-skeleton/dist/skeleton.css';
import arrow_down from '../assets/images/angle_up_down.svg';
import arrow_down_green from '../assets/images/arrow_down_green.svg';
import assign from '../assets/images/assign.svg';
import { useNavigate } from 'react-router-dom';
import HtmlAsText from './createmode/HtmlAsText';
import StudentBookContent from './studentDashboard/studentBookContent';

export const StudentSidebar = ({
  anchorBook = () => {},
  scrollChapter = () => {},
  scrollSection = () => {},
  draggedOver = null,
  mode,
}) => {
  const token = localStorage.getItem('xAuthToken');

  const emails = useSelector((state) => state.entities.instructors.instructors) || [];
  const { book } = useSelector((state) => state.entities.student);
  const { reader } = useSelector((state) => state.ui.reader);
  const { settings } = useSelector((state) => state.settings.settings);
  const [sideBar, setSideBar] = useState([]);
  const [sideBarSection, setSideBarSection] = useState([]);
  const [sideBarActivity, setSideBarActivity] = useState([]);
  const [tabConent, setTabContent] = useState('content');
  const [saveNote, setSaveNotes] = useState('');

  const [subTab, setSubTab] = useState('all');
  const [showDatePicker, setShowDatePicker] = useState('');
  const [setStartDate] = useState('');
  const options = { day: '2-digit', month: '2-digit', year: 'numeric' };

  /* ............................ */

  //Create Class States
  const dispatch = useDispatch();
  const emailsMap = {};
  for (const email of emails) {
    emailsMap[email.email] = email;
  }
  const navigate = useNavigate();
  const [, setModalShow] = useState(false);

  const setTabs = (e, value) => {
    setTabContent(value);
  };

  const expendSidebar = (e, value) => {
    e.stopPropagation();
    if (sideBar.includes(value)) {
      setSideBar(sideBar.filter((e) => e !== value));
    } else {
      setSideBar([...sideBar, value]);
    }
  };

  const toggleSidebarSection = (e, value) => {
    e.stopPropagation();
    if (sideBarSection.includes(value)) {
      setSideBarSection(sideBarSection.filter((sec) => sec !== value));
    } else {
      setSideBarSection([...sideBarSection, value]);
    }
  };

  const toggleSidebarActivity = (e, value) => {
    if (sideBarActivity.includes(value)) {
      setSideBarActivity(sideBarActivity.filter((e) => e !== value));
    } else {
      setSideBarActivity([...sideBarActivity, value]);
    }
  };

  const DynamicSpan = (props) => {
    const now = new Date();
    const assignementDate = new Date(props.date);
    const initialText = props.assigned
      ? new Date(props.date).toLocaleDateString('en-029', options)
      : `ASSIGN`;
    const [text, setText] = useState(initialText);
    const [isMouseTop, setIsMouseTop] = useState(false);
    const handleOver = (e) => {
      if (showDatePicker !== `${props.chapter}.${props.section}.${props.activity}`)
        setText(`${props.assigned ? initialText : 'ASSIGN'}`);
      setIsMouseTop(true);
    };
    const handleLeave = (e) => {
      setText(initialText);
      setIsMouseTop(false);
    };

    const handleClick = (e) => {
      e.stopPropagation();
      if (showDatePicker === `${props.chapter}.${props.section}.${props.activity}`) {
        setShowDatePicker('');
      } else {
        setShowDatePicker(`${props.chapter}.${props.section}.${props.activity}`);
      }
    };
    return (
      <div
        className={`${
          showDatePicker === `${props.chapter}.${props.section}.${props.activity}`
            ? ''
            : 'dynamic-span'
        }`}
      >
        {showDatePicker !== `${props.chapter}.${props.section}.${props.activity}` && (
          <div
            className='chepter'
            onMouseOver={handleOver}
            onMouseLeave={(e) => {
              handleLeave(e);
            }}
            onClick={(e) => {
              setStartDate(
                assignementDate !== ''
                  ? new Date(assignementDate).toLocaleString('en-029')
                  : new Date('1/1/1970').toLocaleString('en-029')
              );
              handleClick(e);
            }}
          >
            {(isMouseTop || showDatePicker) && text !== 'ASSIGN' && (
              <div className='select-a-day'>select a day</div>
            )}
          </div>
        )}
      </div>
    );
  };

  const renderNewActivities = () => {
    return (
      <div className='Contents_tabs custom_tabs_chapater'>
        {' '}
        {book.activities.map((activity, actIndex) => (
          <div
            className='accordion-item activity-element'
            key={activity.chapter + '.' + activity.section + '.' + actIndex}
          >
            <h2 className='accordion-header activity-element'>
              <div
                // className={
                //   sideBarActivity.includes(`${chapter._id}-${section._id}-${activity._id}`) ? "accordion-button active main_head fw_700" : "accordion-button collapsed main_head fw_700"
                // }
                className={`${
                  sideBarActivity.includes(
                    `${activity.chapter}-${activity.section}-${activity._id}`
                  )
                    ? 'accordion-button active main_head fw_700'
                    : 'accordion-button main_head fw_700 collapsed'
                } ${activity.assigned ? 'assigned' : ''} activity-btn activity-element`}
                type='button'
                data-bs-toggle='collapse'
                data-bs-target='#panelsStayOpen-collapseKnowledge'
                aria-expanded={sideBarActivity.includes(
                  `${activity.chapter}-${activity.section}-${activity._id}`
                )}
                aria-controls='panelsStayOpen-collapseKnowledge'
                onClick={(e) => {
                  toggleSidebarActivity(
                    e,
                    `${activity.chapter}-${activity.section}-${activity._id}`
                  );
                }}
              >
                <div className='chap_title activity-element'>
                  <span className='eclipses'>{activity.title}</span>
                  <img src={arrow_down} alt='arrow' className='activity-element' />
                </div>{' '}
                <DynamicSpan
                  activity={actIndex}
                  chapter={activity.chapter}
                  section={activity.section}
                  assigned={activity.assigned}
                  date={activity.assigned ? activity.assignedDate : ''}
                />
              </div>
            </h2>

            <div
              // id="panelsStayOpen-collapseSubdisciplines"
              className={
                sideBarActivity.includes(`${activity.chapter}-${activity.section}-${activity._id}`)
                  ? 'accordion-collapse collapse event-less show'
                  : 'accordion-collapse collapse event-less'
              }
              aria-labelledby='panelsStayOpen-Subdisciplines'
            >
              <div className='accordion-body event-less'>
                {activity.questions.map((question, quesIndex) => (
                  <div key={quesIndex} className='event-less'>
                    <p className='event-less'>
                      <a href='#!' className='event-less'>
                        {question.text}
                      </a>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const dynamicChapterClass = (chapter, index) => {
    let className = 'accordion-button main_head chapter_element chapter-btn chapter_element_left';
    className += sideBar.includes(chapter.title) ? ' active' : ' collapsed';
    className += reader.chapter === index ? '  fw_700' : '';
    className +=
      draggedOver && draggedOver.type === 'chapter' && draggedOver.index === chapter._id
        ? ' trigger'
        : '';
    // className += book.activities.findIndex((e) => e.chapter._id === chapter._id && !e.section) > -1 ? ' purple' : '';
    return className;
  };
  const dynamicSectionClass = (chapter, section, index, secIndex) => {
    let className = 'section-btn section_element section_element_left';
    className +=
      draggedOver &&
      draggedOver.type === 'section' &&
      draggedOver.index === chapter._id + '.' + section._id
        ? ' trigger'
        : '';
    className += sideBarSection.includes(`${chapter._id}-${section._id}`)
      ? ' accordion-button main_head active'
      : ' accordion-button main_head collapsed';
    // if (book.activities.findIndex((e) => e.section === section._id && e.paragraphs.length === 0) > -1) {
    //   className += ' purple';
    // }
    return className;
  };

  const renderChapters = () => {
    return (
      <div className='tab-pane fade show active custom_tabs_chapater '>
        <div className='accordion ' id='accordion_active' style={{ marginTop: '0px' }}>
          {book.chapters.map((chapter, index) => {
            const chapActivities = book.activities.filter(
              (e) => e.chapter === chapter._id && !e.section
            );
            const chapActivity = chapActivities[0];
            return (
              <div key={index}>
                <div className={`accordion-item`}>
                  <h2
                    className='accordion-header'
                    // id="panelsStayOpen-Preface"
                  >
                    <div
                      className={dynamicChapterClass(chapter, index)}
                      type='button'
                      aria-expanded={sideBar.includes(chapter.title) ? true : false}
                      aria-controls='panelsStayOpen-collapsePreface'
                      data-id={chapter._id}
                      style={{ padding: '0px' }}
                    >
                      {'    '}{' '}
                      <div
                        style={{
                          borderRadius: '2px',
                          padding: '4px  6px 4px 2px',
                        }}
                        // className="chap_title bg_grey"
                        className={`chap_title ${
                          sideBar.includes(chapter.title) ? 'bg_grey' : ''
                        }`}
                        // onClick={(e) => scrollChapter(chapter._id, index)}
                        onClick={(e) => {
                          expendSidebar(e, chapter?.title);
                          // setScrollId(chapter._id);

                          scrollChapter(chapter?._id, index);
                        }}
                      >
                        <span className='eclipses'>
                          <HtmlAsText htmlContent={chapter?.title} />
                        </span>
                        {/* {chapter?.title && (
                          <img
                            // onClick={(e) => expendSidebar(e, chapter.title)}
                            src={arrow_down}
                            alt='arrow'
                          />
                        )} */}

                        {chapter?.sections?.length > 0 && <img src={arrow_down} alt='arrow' />}
                      </div>{' '}
                    </div>
                  </h2>

                  <div
                    style={{
                      marginBottom: chapter.sections.length > 0 ? '8px' : '0px',
                    }}
                    // id="panelsStayOpen-collapsePreface"
                    className={
                      sideBar.includes(chapter.title)
                        ? 'accordion-collapse collapse show'
                        : 'accordion-collapse collapse'
                    }
                    aria-labelledby='panelsStayOpen-Preface'
                  >
                    {/* <div className="accordion-body">
                      <p className="f14">{chapter.description}</p>
                    </div> */}
                    <div
                      className='accordion-body bl'
                      style={{
                        marginLeft: '5px',
                        marginTop: chapter.sections.length > 0 ? '10px' : '0px',

                        display: chapter.sections.length > 0 ? 'flex' : 'none',
                        flexDirection: 'column',
                        gap: '8px',
                      }}
                    >
                      {book.activities
                        .filter((e) => e.chapter?._id === chapter?._id && !e.section)
                        .map((e, index) => (
                          <div key={index} className='section_element'>
                            <div className='accordion-item'>
                              <h2 className='accordion-header'>
                                <button
                                  style={{
                                    textTransform: 'capitalize',
                                    margin: '0px 1px 0px 16px',
                                    padding: '0px 0px',
                                    fontWeight: '400',
                                  }}
                                  className={dynamicChapterClass(chapter, index)}
                                  data-id={`${chapter._id}`}
                                  type='button'
                                  data-bs-toggle='collapse'
                                  aria-expanded={sideBarSection.includes(`${chapter._id}`)}
                                >
                                  <div
                                    className='purple'
                                    style={{ fontWeight: '400' }}
                                    onClick={(e) => {
                                      scrollChapter(chapter?._id);
                                      toggleSidebarSection(e, `${chapter._id}`);
                                    }}
                                  >
                                    <HtmlAsText
                                      htmlContent={e.title}
                                      style={{ fontWeight: '400' }}
                                    />
                                  </div>{' '}
                                </button>
                              </h2>
                            </div>
                          </div>
                        ))}
                      {chapter.sections.map((section, secIndex) => {
                        const sectActivities = book.activities.filter(
                          (e) => e.section === section._id && !e.paragraphs.length
                        );
                        const sectActivity = sectActivities[0];
                        return (
                          <div key={secIndex} className='section_element'>
                            <div className='accordion-item'>
                              <h2
                                className='accordion-header'
                                // id="panelsStayOpen-Biological"
                              >
                                <button
                                  className={dynamicSectionClass(
                                    chapter,
                                    section,
                                    index,
                                    secIndex
                                  )}
                                  style={{
                                    textTransform: 'capitalize',
                                    margin: '0px 1px 0px 16px',
                                    padding: '3px 0px',
                                  }}
                                  data-id={`${chapter._id}.${section._id}`}
                                  type='button'
                                  data-bs-toggle='collapse'
                                  aria-expanded={sideBarSection.includes(
                                    `${chapter._id}-${section._id}`
                                  )}
                                >
                                  <div
                                    className='chap_title'
                                    onClick={(e) => {
                                      scrollSection(chapter._id + '.' + section._id);
                                      toggleSidebarSection(e, `${chapter._id}-${section._id}`);
                                    }}
                                  >
                                    <span className='eclipses sects'>
                                      <HtmlAsText htmlContent={section.title} />
                                    </span>
                                    {/* <img src={arrow_down} alt='arrow' /> */}
                                    {(book.activities.some(
                                      (e) =>
                                        (typeof e.section === 'object'
                                          ? e.section._id
                                          : e.section) === section._id && !e.paragraph
                                    ) ||
                                      section?.paragraphs?.some((p) =>
                                        book.activities.some((e) =>
                                          e.paragraphs?.some(
                                            (par) =>
                                              (typeof par === 'object' ? par._id : par) === p._id
                                          )
                                        )
                                      )) && (
                                      <img
                                        onClick={(e) =>
                                          toggleSidebarSection(e, `${chapter._id}-${section._id}`)
                                        }
                                        src={
                                          sideBarSection.includes(`${chapter._id}-${section._id}`)
                                            ? arrow_down
                                            : arrow_down
                                        }
                                        alt='arrow'
                                        style={{ cursor: 'pointer' }}
                                      />
                                    )}
                                  </div>{' '}
                                </button>
                                {(book.activities.some(
                                  (e) =>
                                    (typeof e.section === 'object' ? e.section._id : e.section) ===
                                      section._id && !e.paragraph
                                ) ||
                                  section?.paragraphs?.some((p) =>
                                    book.activities.some((e) =>
                                      e.paragraphs?.some(
                                        (par) =>
                                          (typeof par === 'object' ? par._id : par) === p._id
                                      )
                                    )
                                  )) && (
                                  <div
                                    className={
                                      sideBarSection.includes(`${chapter._id}-${section._id}`)
                                        ? 'accordion-collapse collapse show'
                                        : 'accordion-collapse collapse'
                                    }
                                    aria-labelledby='panelsStayOpen-Biological'
                                  >
                                    <div
                                      className='accordion-body bl'
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '8px',
                                      }}
                                    >
                                      {/* Section Activities */}
                                      {book.activities
                                        .filter(
                                          (e) =>
                                            (typeof e.section === 'object'
                                              ? e.section._id
                                              : e.section) === section._id && !e.paragraph
                                        )
                                        .map((e, index) => (
                                          <div key={index} className='section_element'>
                                            <div className='accordion-item'>
                                              <h2 className='accordion-header'>
                                                <button
                                                  style={{
                                                    textTransform: 'capitalize',
                                                    margin: '0px 1px 0px 16px',
                                                    padding: '0px 0px',
                                                    fontWeight: '400',
                                                  }}
                                                  className={dynamicSectionClass(
                                                    section,
                                                    section,
                                                    index
                                                  )}
                                                  data-id={`${section._id}`}
                                                  type='button'
                                                  data-bs-toggle='collapse'
                                                  aria-expanded={sideBarSection.includes(
                                                    `${chapter._id}-${section._id}`
                                                  )}
                                                >
                                                  <div
                                                    className='purple'
                                                    style={{ fontWeight: '400' }}
                                                    onClick={(e) => {
                                                      scrollChapter(
                                                        `${chapter?._id}.${section?._id}`
                                                      );
                                                      toggleSidebarSection(
                                                        e,
                                                        `${chapter._id}.${section._id}`
                                                      );
                                                    }}
                                                  >
                                                    <HtmlAsText
                                                      htmlContent={e.title}
                                                      style={{ fontWeight: '400' }}
                                                    />
                                                  </div>
                                                </button>
                                              </h2>
                                            </div>
                                          </div>
                                        ))}

                                      {/* Paragraph Activities (if uncommented) */}
                                      {/* section.paragraphs?.map((paragraph, parIndex) => (
        paragraph.text && (
          <div key={parIndex}>
            <div className="accordion-item p-element">
              <h2 className="accordion-header">
                <div className="accordion-body" style={{ marginTop: '0px' }}>
                  <p className="left-ps" style={{ marginBottom: '0px' }}>
                    <a
                      href="#!"
                      style={{
                        marginBottom: '0px',
                        fontWeight: '500',
                        textTransform: 'none',
                        pointerEvents: 'auto',
                        color: 'inherit',
                      }}
                      className={`cursor eclipses ps ${
                        book.activities.some((e) =>
                          e.paragraphs?.some((par) =>
                            (typeof par === 'object' ? par._id : par) === paragraph._id
                          )
                        )
                          ? 'purple'
                          : ''
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(setChapter(index));
                        dispatch(setSection(secIndex));
                        anchorBook?.(chapter._id, section._id, paragraph._id);
                      }}
                    >
                      <HtmlAsText htmlContent={paragraph.text} />
                    </a>
                  </p>
                </div>
              </h2>
            </div>
          </div>
        )
      )) */}
                                    </div>
                                  </div>
                                )}
                              </h2>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  const handleLoggedInPopup = () => {
    token ? setModalShow(false) : setModalShow(true);
  };
  function UpdateLogo({ siteMode }) {
    let logoSrc = '';
    switch (siteMode) {
      case 'explore':
        logoSrc = greyledRead;
        break;
      case 'prof':
      case 'teach':
        logoSrc = greyledTeach;
        break;
      case 'student':
        logoSrc = greyledLearn;
        break;
      default:
        logoSrc = greyledRead;
    }
    return <img src={logoSrc} alt='logo' />;
  }

  return (
    <div>
      <div
        onClick={handleLoggedInPopup}
        className={
          settings.siteMode === 'teach'
            ? 'left_side_bar teach  custom_nav'
            : 'left_side_bar custom_nav'
        }
        style={{
          paddingLeft: '16px',
          display: settings.bookMode ? 'none' : 'block',
        }}
      >
        {/* {settings.siteMode === "teach" ? ( */}
        <div
          className={`logo_wrap ${settings.siteMode === 'teach' ? 'd-flex' : ''}`}
          style={{ marginBottom: '25.02px' }}
        >
          <UpdateLogo siteMode={settings.siteMode} />
          {settings.siteMode === 'teach' && (
            <Fragment>
              <div
                style={{
                  width: '.5px',
                  height: '24px',
                  background: '#0E9592',
                }}
              ></div>
              <img src={assign} alt='' />
              <img src={arrow_down_green} alt='' />
            </Fragment>
          )}
        </div>
        {/* ) : (
            ""
          )} */}

        <ul className='nav nav-tabs nav-justified' id='myTab' role='tablist'>
          <li className='nav-item' role='presentation'>
            <button
              className={tabConent === 'content' ? 'nav-link active' : 'nav-link'}
              id='home-tab'
              data-bs-toggle='tab'
              data-bs-target='#Contents'
              type='button'
              role='tab'
              aria-controls='Contents'
              aria-selected='true'
              onClick={(e) => setTabs(e, 'content')}
            >
              Contents
            </button>
          </li>
          <li className='nav-item' role='presentation'>
            <button
              className={tabConent === 'takeNotes' ? 'nav-link active' : 'nav-link'}
              id='classroom-tab'
              data-bs-toggle='tab'
              data-bs-target='#classroom'
              type='button'
              role='tab'
              aria-controls='profile'
              aria-selected='false'
              onClick={(e) => {
                setTabs(e, 'takeNotes');
              }}
            >
              Take notes
            </button>
          </li>
        </ul>
        <div className='tab-content' id='myTabContent'>
          <div
            className={
              tabConent === 'content' ? 'tab-pane fade show active' : 'tab-pane fade show'
            }
            id='Contents'
            role='tabpanel'
            aria-labelledby='Contents-tab'
          >
            <StudentBookContent
              book={book}
              subTab={subTab}
              renderChapters={renderChapters}
              renderNewActivities={renderNewActivities}
              mode={'studentMode'}
            />
          </div>
          {tabConent === 'takeNotes' && (
            <div>
              <textarea
                type='text'
                value={saveNote}
                placeholder='Start typing your notes'
                className='take-notes'
                onChange={(e) => setSaveNotes(e.target.value)}
              />
            </div>
          )}
        </div>
      </div>

      <>
        {/* Your other content here... */}
        {/*  <Modal
          show={modalShow}
          onHide={handleClose}
          backdrop="static"
          className="modal fade custom_modal_not model_with"
          id="Not_yet"
          tabindex="-1"
          aria-labelledby="Not_yetLabel"
          aria-hidden="true">
          <div className="modal-width">
            <ModalBody>
              <button
                onClick={handleClose}
                type="button"
                className="btn_close_modal"
                data-bs-dismiss="modal"
                aria-label="Close">
                <img src="/assets/images/cross.png" alt="cross" />
              </button>
              <div className="modal-body modal_content_main_Wrap">
                <div className="modal_content_box" style={{marginLeft: "0px"}}>
                  <h1>not yet!</h1>
                  <p>
                    Complete signup to see assignments, read the book and
                    connect with other students in your class.
                  </p>
                </div>
                <div className="btn_wrap_info" style={{marginTop: "40px"}}>
                 
                  <button
                    type="button"
                    className="btn_black_theme"
                    onClick={handleCustomClick}>
                    Take me back to signup
                   
                  </button>
                  <button type="button" className="btn_outline_dark mt_24">
                    I just want to read
                  </button>
                </div>
              </div>
            </ModalBody>
          </div>
        </Modal> */}
      </>
    </div>
  );
};
function BookContent({ book, subTab, renderChapters, renderNewActivities }) {
  return (
    <div className='Contents_tabs'>
      <div className='tabs_content classroom_wrap' id='myContents' style={{ padding: '0px' }}>
        <div className='Contents_Wrap_create accordion_Wrap'>
          <h1 className='f-16 mini_title' style={{ color: 'var(--Black, #000)' }}>
            {book?.name || ' '}
          </h1>
        </div>
        {subTab === 'all' && (
          <div
            className='tab-pane fade show active custom_tabs_chapater'
            aria-labelledby='all-tab'
          >
            {renderChapters()}
          </div>
        )}
        {subTab === 'activities' && (
          <div className='tab-pane fade show active' aria-labelledby='Activities-tab'>
            {renderNewActivities()}
          </div>
        )}
        {subTab === 'activities-chapters' && (
          <div>
            <div className='sidebar_subheading'>
              <span>CHAPTERS</span>
              <img src={funnel} alt='' />
            </div>
            <hr />
            <div className='vh-50'>{renderChapters()}</div>
            <div className='sidebar_subheading'>
              <span>ACTIVITIES</span>
              <img src={funnel} alt='' />
            </div>
            <hr />
            <div className='vh-50'>{renderNewActivities()}</div>
          </div>
        )}
      </div>
    </div>
  );
}
